import { useInitDependency } from '@servicetitan/cp-react-hooks';
import { portalStoreToken } from '@servicetitan/cp-ui';
import { Toast } from '@servicetitan/design-system';
import { observer } from 'mobx-react';
import { WebPortalStore } from '../../stores/portal.store';

export const AppNotifications = observer(() => {
    const { hideNotification, notifications } = useInitDependency<WebPortalStore>(
        portalStoreToken as any
    );

    return (
        <Toast.Group>
            {notifications.map(item => (
                <Toast
                    key={item.key}
                    title={item.data.title}
                    status={item.data.status}
                    onClose={() => hideNotification(item.key)}
                    duration={5000}
                    portal={false}
                >
                    {item.data.description}
                </Toast>
            ))}
        </Toast.Group>
    );
});
